export default [
  {
    path: '/mission-newbie',
    component: () => import('./views/Index'),
    name: 'mission-newbie',
    redirect: { name: 'mission-newbie-list' },
    children: [
      {
        path: '',
        name: 'mission-newbie-list',
        component: () => import('./views/List'),
        meta: {
          resource: 'auth',
        },
      },
      {
        path: 'detail/:mission_id',
        name: 'mission-newbie-detail',
        component: () => import('./views/Detail'),
        meta: {
          resource: 'auth',
        },
      },
    ],
  },
]
